import { render, staticRenderFns } from "./HighlightModal.vue?vue&type=template&id=3c0fc73b&"
import script from "./HighlightModal.vue?vue&type=script&lang=js&"
export * from "./HighlightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports